// extracted by mini-css-extract-plugin
export default {"pagina_conteudo":"NovoGrupoDeUsuario_pagina_conteudo__U6WzR"};